import { ServiceStartType } from "@Light/components/enroll/types";
import React from "react";
import { BaseConfirmation } from "./BaseConfirmation";

type VariantProps = {
  dueDate: string;
  exitTo?: string;
};

export type ConfirmationProps =
  { immediateStartProps: VariantProps } | { deferredStartProps: VariantProps };

const ImmediateConfirmation: React.FC<VariantProps> = ({
  dueDate,
  exitTo = "/",
}) => (
  <BaseConfirmation
    serviceStartType={ServiceStartType.Immediate}
    dueDate={dueDate}
    exitTo={exitTo}
    bodyText="We'll handle switching your service from your current provider — no interruption in your electricity will occur."
  />
);

const DeferredConfirmation: React.FC<VariantProps> = ({
  dueDate,
  exitTo = "/",
}) => (
  <BaseConfirmation
    serviceStartType={ServiceStartType.Deferred}
    dueDate={dueDate}
    exitTo={exitTo}
    bodyText="Once you get closer to the start date, we'll send you the locked-in energy rates to confirm."
  />
);

export const Confirmation: React.FC<ConfirmationProps> = (props) => {
  if ("immediateStartProps" in props)
    return <ImmediateConfirmation {...props.immediateStartProps} />;
  if ("deferredStartProps" in props)
    return <DeferredConfirmation {...props.deferredStartProps} />;
  throw new Error(
    "Confirmation component must have either immediateStartProps or deferredStartProps",
  );
};
